function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.345,
    height: 120,
    viewBox: "0 0 166.345 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8cpeq7pf2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 664",
    transform: "translate(0 -.315)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h166.345v120H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pvgsismnfb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9153",
    transform: "translate(0 .12)",
    style: {
      fill: "none"
    },
    d: "M0 0h109v109H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17",
    transform: "translate(0 .314)",
    style: {
      clipPath: "url(#8cpeq7pf2a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10504"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10505",
    style: {
      clipPath: "url(#pvgsismnfb)"
    },
    transform: "translate(29 5.565)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46472",
    d: "M54.409 108.732q-26.747 0-53.493.022c-.775 0-.916-.174-.916-.928Q.034 54.388 0 .95C0 .246.071 0 .9 0q53.491.044 106.984 0c.734 0 .863.156.863.874q-.033 53.491.007 106.982c0 .85-.276.886-.958.885q-26.694-.026-53.387-.014",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46473",
    d: "M12.742 45.993c0-10.965.007-21.93-.031-32.894 0-.946.339-1.074 1.161-1.073q17.474.036 34.949.016H113.1c1.342 0 1.343 0 1.343 1.382q-.003 16.288-.011 32.576a1.573 1.573 0 0 1-1.188.346c-1.659 0-3.318.037-4.977-.016-.67.062-1.341.031-2.011.031q-45.689 0-91.378-.006c-.723 0-1.5.181-2.137-.361",
    transform: "translate(-9.111 -8.62)",
    style: {
      fill: "#f6d780"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46474",
    d: "M12.821 131.96c.494.007.987.02 1.481.02h92.607c.493 0 .987.02 1.48.03a1.277 1.277 0 0 1 .19 1.2 55.855 55.855 0 0 1-2.133 8.157 1.421 1.421 0 0 1-.827 1.028 8.121 8.121 0 0 1-2.108.118q-40.693.005-81.387 0c-2.186 0-2.179 0-2.189 2.2-.011 2.545.042 5.09-.027 7.634.067 3.22.024 6.439.027 9.658q.011 11.889 0 23.777a5.878 5.878 0 0 1-.128 1.79.722.722 0 0 1-.973.382c-1.8-.484-3.629-.85-5.38-1.5a1.161 1.161 0 0 1-.632-.53v-53.967",
    transform: "translate(-9.19 -94.587)",
    style: {
      fill: "#eaf6fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46475",
    d: "M105.76 142.159a43.957 43.957 0 0 0 2.54-10.129l6.122-.045.015 26.421q0 20.161.022 40.322c0 .979-.266 1.233-1.235 1.233q-49.616-.037-99.233 0c-1.014 0-1.308-.256-1.293-1.285.062-4.243.032-8.488.036-12.732a57.321 57.321 0 0 0 6.764 1.9c.577.753.321 1.633.338 2.458.056 2.71-.276 2.5 2.528 2.5q19.1.008 38.195 0a11.346 11.346 0 0 1 1.268.029q1.748-.051 3.5 0a14.979 14.979 0 0 1 1.587-.03h38.945c1.386-.016 1.441-.068 1.456-1.419.006-.495 0-.99 0-1.485v-36.158a10.158 10.158 0 0 1 .03-1.27c-.038-2.706-.007-5.412-.017-8.118-.005-1.483 0-1.483-1.331-1.99a.669.669 0 0 1-.238-.2",
    transform: "translate(-9.104 -94.605)",
    style: {
      fill: "#c6e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46476",
    d: "M81.078 50.941c0-2.611.037-5.223-.021-7.833-.02-.889.243-1.139 1.123-1.12 2.287.048 2.288.007 2.288 2.265 0 4.209-.011 8.417.009 12.626 0 .93-.184 1.741-1.149 2.033a1.849 1.849 0 0 1-2.184-1.074q-2.107-3.365-4.217-6.727a3.38 3.38 0 0 0-.935-1.075v6.608c0 2.382 0 2.349-2.395 2.369-.789.007-1.02-.215-1.014-1.012.036-4.668.026-9.337.01-14a1.738 1.738 0 0 1 1.166-1.918 1.706 1.706 0 0 1 2.1.975c1.425 2.314 2.881 4.608 4.326 6.909.221.352.448.7.673 1.048l.22-.07",
    transform: "translate(-52.027 -30.094)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46477",
    d: "M300.1 50.511c0-2.158-.008-4.316 0-6.474.007-1.358.594-1.981 1.9-1.99 2.471-.016 4.943.012 7.414-.016.627-.007.852.166.867.832.058 2.577.082 2.576-2.5 2.576h-3.284c-.212 0-.508-.079-.621.03-.841.8-.2 1.837-.376 2.756-.1.554.291.616.728.614 1.694-.009 3.39.027 5.084-.017.721-.019.975.177.976.941 0 2.47.032 2.47-2.4 2.47h-3.389c-.212 0-.508-.079-.621.029-.843.8-.2 1.837-.377 2.755-.1.553.29.617.728.615 1.694-.009 3.39.027 5.084-.017.72-.019.976.176.976.94 0 2.471.033 2.471-2.4 2.471-1.907 0-3.813.006-5.72 0-1.478-.006-2.062-.581-2.068-2.042-.009-2.158 0-4.316 0-6.474",
    transform: "translate(-215.105 -30.127)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46478",
    d: "M174.4 50.558v-3.183a5.09 5.09 0 1 1 10.17.015q.009 3.183 0 6.366a5.106 5.106 0 0 1-5.142 5.3 5.161 5.161 0 0 1-5.028-5.316v-3.183",
    transform: "translate(-125.008 -30.158)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46479",
    d: "M126.484 47.481c0-1.52.027-3.041-.013-4.56-.017-.666.154-.922.875-.931 2.528-.032 2.528-.06 2.528 2.445 0 2.086.064 4.174-.023 6.256-.058 1.375.914 2.161 1.506 3.17.232.4.4.044.531-.137a5.477 5.477 0 0 0 1.413-3.736c-.138-2.325-.016-4.664-.048-7-.01-.687.119-1 .912-1 2.491-.007 2.491-.041 2.491 2.484 0 2.439-.011 4.878.007 7.318a2.776 2.776 0 0 1-.5 1.682c-1.042 1.51-2.031 3.056-3.063 4.573a1.711 1.711 0 0 1-3.03.03c-1.106-1.594-2.161-3.223-3.243-4.834a2.206 2.206 0 0 1-.345-1.306c.013-1.485 0-2.969 0-4.454",
    transform: "translate(-90.652 -30.092)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46480",
    d: "M246.091 50.391a19.327 19.327 0 0 0-.01-2.014c-.432-4.078 2.185-6.866 6.536-6.495a5.531 5.531 0 0 1 4.1 1.839 3.689 3.689 0 0 1 .334.409c.5.815 1.274 1.911.761 2.591-.573.758-1.9.2-2.89.263-.391.024-.36-.379-.468-.613a1.717 1.717 0 0 0-1.675-1.064c-2.382-.037-3.461-.228-3.307 3.149.077 1.693 0 3.393.017 5.089.011 1.338.609 1.929 1.941 1.953.494.009.988 0 1.481 0a1.767 1.767 0 0 0 1.359-.7c.262-.306.122-.941.679-.966a16.189 16.189 0 0 1 2.744.042c.446.057.264.584.179.9a4.828 4.828 0 0 1-3.725 3.911c-2.347.466-4.712.59-6.6-1.378a4.923 4.923 0 0 1-1.449-3.522v-3.393",
    transform: "translate(-176.354 -29.997)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46481",
    d: "M52.051 50.561c0 2.512-.02 5.024.013 7.536.009.679-.178.913-.887.92-2.516.028-2.516.056-2.516-2.46 0-4.493.018-8.987-.017-13.48-.007-.815.187-1.1 1.051-1.084 2.356.04 2.356 0 2.356 2.305v6.263",
    transform: "translate(-34.867 -30.099)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46482",
    d: "M222.257 50.45c0-2.512.02-5.024-.013-7.536-.009-.68.18-.912.888-.92 2.515-.028 2.515-.055 2.515 2.461 0 4.494-.019 8.987.017 13.48.006.816-.19 1.1-1.052 1.083-2.355-.04-2.356 0-2.356-2.306V50.45",
    transform: "translate(-159.301 -30.097)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46483",
    d: "M79.087 243.865q-20.729.008-41.457.03c-.751 0-.974-.241-.951-.971.046-1.447.01-2.9.008-4.344l.014-35.484a1.966 1.966 0 0 1 1.411-.324q19.758-.01 39.515 0c1.552 0 1.787.236 1.789 1.788q.016 18.947 0 37.894a1.924 1.924 0 0 1-.33 1.41",
    transform: "translate(-26.29 -145.34)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46484",
    d: "M79.067 218.88q-.006-19.669-.015-39.339c0-1.585.172-1.408-1.416-1.409q-20.478-.016-40.955-.022c0-3.005.032-6.011-.031-9.015-.02-.93.222-1.18 1.167-1.179q26.623.045 53.246.022h30.593c.423 0 .846-.019 1.269-.029 1.9.088 1.9.088 1.9 1.991q0 4.109-.015 8.218a2.634 2.634 0 0 1-1.928.353q-18.956.013-37.912.008c-2.35 0-2.178-.167-2.179 2.182q-.006 18.144-.008 36.288a2.65 2.65 0 0 1-.353 1.932h-3.363",
    transform: "translate(-26.27 -120.354)",
    style: {
      fill: "#f6d780"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46485",
    d: "M198.269 244.686c0-13.147.023-26.294-.013-39.441 0-1.076.265-1.337 1.334-1.334q20.529.052 41.058.013.007 19.942.027 39.884c0 .694-.215.908-.906.907q-20.75-.032-41.5-.027",
    transform: "translate(-142.107 -146.16)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46486",
    d: "M189.743 59.213c0 1.1.022 2.193-.007 3.288a1.689 1.689 0 1 1-3.374-.029q-.034-3.288 0-6.576a1.695 1.695 0 1 1 3.378.029c.021 1.1 0 2.192 0 3.288",
    transform: "translate(-133.57 -38.765)",
    style: {
      fill: "#f6d781"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46487",
    d: "M71.46 237.331c-5.223 0-10.445-.02-15.668.019-.881.007-1.235-.145-1.2-1.138.074-2.276.016-2.278 2.267-2.278 10.128 0 20.256.014 30.383-.022.974 0 1.355.166 1.309 1.247-.091 2.169-.024 2.171-2.163 2.171z",
    transform: "translate(-39.128 -167.665)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46488",
    d: "M71.58 269.918c5.293 0 10.587.023 15.88-.022.907-.008 1.115.272 1.1 1.133-.049 2.284-.009 2.285-2.254 2.285-10.163 0-20.326-.016-30.489.024-1 0-1.23-.3-1.2-1.243.062-2.177.017-2.179 2.148-2.179H71.58",
    transform: "translate(-39.142 -193.458)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46489",
    d: "M71.674 305.907c5.223 0 10.445.02 15.668-.02.887-.007 1.23.155 1.2 1.142-.074 2.273-.017 2.275-2.27 2.275-10.128 0-20.256-.014-30.384.022-.979 0-1.35-.176-1.306-1.251.09-2.165.024-2.168 2.166-2.168z",
    transform: "translate(-39.12 -219.256)",
    style: {
      fill: "#9fa7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46490",
    d: "M257.925 231.851c-.864.169-1.5-.017-1.806-1.287a3.19 3.19 0 0 0-3.84-2.026 3.414 3.414 0 0 0-2.621 3.621 3.365 3.365 0 0 0 3.229 3.073 6.787 6.787 0 0 1 2.723 13.02c-.733.312-.979.692-.878 1.41a.78.78 0 0 1 0 .106c0 2.768 0 2.755-2.8 2.477-.465-.046-.661-.225-.587-.65a3.361 3.361 0 0 0-2.232-4.139c-1.729-.788-2.457-2.629-2.814-4.512-.135-.712.094-.995.811-.907a2.827 2.827 0 0 0 .74 0c1.122-.163 1.8.049 2.145 1.383a3.163 3.163 0 0 0 3.792 1.936 3.462 3.462 0 0 0 2.625-3.628 3.363 3.363 0 0 0-3.233-3.068 6.816 6.816 0 0 1-5.6-2.915 6.726 6.726 0 0 1 2.79-10.061 1.4 1.4 0 0 0 .992-1.561c-.046-2.766-.014-2.755 2.779-2.475.466.047.66.228.585.651a3.342 3.342 0 0 0 2.236 4.135c1.623.723 2.323 2.45 2.738 4.21.221.94.064 1.353-.956 1.21a7.192 7.192 0 0 0-.819 0",
    transform: "translate(-176.52 -158.788)",
    style: {
      fill: "#9fa7b1"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.913901978bd611618759364d9d550d93.svg";
export { ForwardRef as ReactComponent };